export default __webpack_public_path__ + "52b3278efee9362efc1566fc2287a660.png";